<template>
  <a-card :bordered="false" :headStyle="{borderBottom:'0px',fontSize:'18px',paddingLeft:'24px'}">
    <a-row slot="title">
      <a-col :span="24">
        <span>价格规则</span>
        <span class="tips">提示：门票单价，指景区供应商给分销商的分销结算价格；产品门市价，指景区显示的销售价格</span>
      </a-col>
    </a-row>
    <div class="content-main">
      <ul>
        <li>本系统价格</li>
        <li>建议销售价</li>
        <li>同行价</li>
        <li>佣金</li>
        <li>市场价</li>
        <li>采购价</li>
      </ul>
      <ul class="right-box">
        <li>石基环企系统价格</li>
        <li>= &nbsp;&nbsp;&nbsp;产品门市价</li>
        <li>= &nbsp;&nbsp;&nbsp;门票单价 + (产品门市价-门票单价)*
          <a-input v-model="upPeerPrice" suffix="%" placeholder="请输入" style="width:150px;"/>
        </li>
        <li>= &nbsp;&nbsp;&nbsp;(产品门市价-门票单价)*
          <a-input v-model="upCommissionPrice" placeholder="请输入" suffix="%" style="width:150px;"/>
        </li>
        <li>= &nbsp;&nbsp;&nbsp;产品门市价</li>
        <li>= &nbsp;&nbsp;&nbsp;门票单价</li>
      </ul>
    </div>
    <div style="padding-left:90px;">
      <a-button type="primary" @click="handleSubmit" :loading="submitLoading">保存</a-button>
    </div>

  </a-card>
</template>

<script>
export default {
  name: 'GalasysAsyncRule',
  data() {
    return {
      submitLoading: false,
      upCommissionPrice: '',// 佣金调整百分比
      upPeerPrice: ''// 同行价调整百分比
    }
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'GalasysConnection', title: '商品绑定' },
      { name: 'GalasysOrderConnection', title: '订单直连' },
      { name: 'GalasysNewAccount', title: '关联账号' }
    ])
    this.getGalasysSyncRules()
  },
  methods: {
    checkForm() {
      let regular = /^([1]?\d{1,2})$/
      if (!this.upPeerPrice) {
        this.$message.error('请输入同行价调整百分比')
        return false
      }
      if (this.upPeerPrice) {
        if (!regular.test(this.upPeerPrice)) {
          this.$message.error('请输入0-100的正整数')
          return false
        }
      }
      if (!this.upCommissionPrice) {
        this.$message.error('请输入佣金调整百分比')
        return false
      }
      if (this.upCommissionPrice) {
        if (!regular.test(this.upCommissionPrice)) {
          this.$message.error('请输入0-100的正整数')
          return false
        }
      }
      return true
    },
    handleSubmit() {
      if (this.checkForm()) {
        this.submitLoading = true
        this.getHttpServices().getServerApiService().post('galasys/sync-rule/add-edit', {
          upCommissionPrice: this.upCommissionPrice,// 佣金调整百分比
          upPeerPrice: this.upPeerPrice,// 同行价调整百分比
          merchantId: this.$store.getters.userInfo.merchantId,// 运营商ID ,
          platformId: this.getPlatformConfig().platformId
        }).then(res => {
          this.getLogUtils().logWithTag('handleSubmit', res)
          this.$message.success('保存成功')
        }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
      }
    },
    // 获取规则
    getGalasysSyncRules() {
      let url = 'galasys/expose/sync-rule/' + this.$store.getters.userInfo.merchantId + '/' + this.getPlatformConfig().platformId
      this.getHttpServices().getServerApiService().get(url).then(res => {
        if (res) {
          this.upCommissionPrice = res.upCommissionPrice ? res.upCommissionPrice : ''// 佣金调整百分比
          this.upPeerPrice = res.upPeerPrice ? res.upPeerPrice : ''// 同行价调整百分比
        }
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    }
  }
}
</script>
<style scoped lang="less">
.tips {
  font-size: 14px;
  padding-left: 15px;
}

ul, li {
  list-style: none;
  padding: 0;
}

.content-main {
  display: flex;

  ul {
    &:first-child {
      background: #E9E9E9;
    }

    li {
      height: 40px;
      line-height: 40px;
      padding: 0 10px;

      &:first-child {
        font-weight: bold;
      }
    }
  }
}
</style>